import {
    ScrollView,
    View,
    ActivityIndicator
} from "../../../custom-packages/react-native-components-in-react/react-native-components-in-react";

import ChocoForm from "../../../custom-packages/react-chocoforms/legacy/ChocoForm";
import AppConfig from "../../../AppConfig";
import {useEffect, useState} from "react";
import QuestionList from "./Components/QuestionList";
import {ThemeButton, BorderlessButton} from "../../../custom-packages/react-button-package/ButtonPackage";
import {useSelector} from "react-redux";
import {useLocation, useNavigate} from "react-router-dom";
import BottomActionBar from "../../../custom-packages/contextual-action-bar/BottomActionBar";
import PollQuestion from "../../../models/poll/PollQuestion";

const TPollCreatorScreen = {
    // English
    "enUS": {
        // FOR POLLING
        'POLL': 'Poll',
        'NAME': 'Name',
        'DESCRIPTION': 'Description (Optional)',
        'QUESTIONS': 'Questions',
        'CANCEL': 'Cancel',
        'SAVE': 'Save',
        'INVALID_NAME': 'Invalid poll name',
        'SAVED_SUCCESSFULLY': 'Poll saved successfully',
    },
    // Spanish
    "esMX": {
        // FOR POLLING
        'POLL': 'Encuesta',
        'NAME': 'Nombre',
        'DESCRIPTION': 'Descripción (Opcional)',
        'QUESTIONS': 'Preguntas',
        'CANCEL': 'Cancelar',
        'SAVE': 'Guardar',
        'INVALID_NAME': 'Nombre de encuesta inválido',
        'SAVED_SUCCESSFULLY': 'La encuesta ha sido guardada',
    }
}

/*const useViewport = () => {
    const [width, setWidth] = React.useState(window.innerWidth);

    React.useEffect(() => {
        const handleWindowResize = () => setWidth(window.innerWidth);
        window.addEventListener("resize", handleWindowResize);
        // Return a function from the effect that removes the event listener
        return () => window.removeEventListener("resize", handleWindowResize);
    }, []);

    // Determine whether the current width of the viewport is less than 500 pixels
    return {isMobile: width < 576};
}*/


const PollCreatorScreen = () => {
    // @ts-ignore
    const auth = useSelector(state => state.Auth)
    const navigate = useNavigate();
    const pollID = new URLSearchParams(useLocation().search).get('pollID');
    const menuID = new URLSearchParams(useLocation().search).get('menuID');

    const [loading, setLoading] = useState(true);
    const [questionsChanged, setQuestionsChanged] = useState(false);

    const [successMsg, setSuccessMsg] = useState(false);

    const [errorMsg] = useState(null);
    const [saving, setSaving] = useState(false);
    const [questions, setQuestions] = useState<Array<PollQuestion>>([new PollQuestion()])
    const [mainForm, setMainForm] = useState({
        controls: {
            pol_name: {
                elementType: 'input',
                elementConfig: {
                    placeholder: TPollCreatorScreen[AppConfig.lang].NAME,
                    autoCapitalize: 'words'
                },
                label: TPollCreatorScreen[AppConfig.lang].NAME,
                value: '',
                errorMessage: '',
                validation: {
                    required: true
                },
            },
            pol_description: {
                elementType: 'input',
                elementConfig: {
                    placeholder: TPollCreatorScreen[AppConfig.lang].DESCRIPTION,
                    autoCapitalize: 'words'
                },
                label: TPollCreatorScreen[AppConfig.lang].DESCRIPTION,
                value: '',
                errorMessage: '',
                validation: {
                    required: false
                },
            },
        },
        isValidForm: false
    });

    //const {isMobile} = useViewport();

    const save = async () => {
        setSaving(true)

        let formData = new FormData();

        if (pollID)
            formData["pol_id"] = pollID;

        for (let key in mainForm.controls) {
            formData[key] = mainForm.controls[key].value;
        }

        const validQuestions = new Array<PollQuestion>()

        for (let i = 0; i < questions.length; i++) {
            if (questions[i].pqu_question)
                validQuestions.push(questions[i]);
        }

        formData["questions"] = validQuestions;

        try {
            const response = await fetch('/Poll/Create?menuID=' + menuID, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': auth.token
                },
                body: JSON.stringify(formData)
            });

            const responseData = await response.json();

            if (responseData.success) {
                if (menuID)
                    navigate('/admin/menus/editor/' + menuID)
                else
                    setSuccessMsg(TPollCreatorScreen[AppConfig.lang].SAVED_SUCCESSFULLY)

                setMainForm({
                    controls: {...mainForm.controls},
                    isValidForm: false
                })
                setQuestionsChanged(false)
            } else {
                // Handle failure here...
            }
        } catch (error) {
            console.error('Error:', error);
        }

        setSaving(false)
    }

    const fetchData = async () => {
        setLoading(true)
        const response = await fetch('/Poll/EditorData/' + pollID, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': auth.token
            },
        });

        const responseData = await response.json();

        setQuestions(responseData.poll.questions)

        const controlsCopy = {...mainForm.controls}

        controlsCopy.pol_name.value = responseData.poll.pol_name
        controlsCopy.pol_description.value = responseData.poll.pol_description

        setMainForm({
            controls: controlsCopy,
            isValidForm: false
        })

        setLoading(false)
    }

    useEffect(() => {
        if (pollID)
            fetchData()
        else
            setLoading(false)
    }, []);

    if (loading)
        return <ActivityIndicator style={{marginTop: 50}}/>

    return <ScrollView>
        <View
            className={'row'}
        >
            <View
                className={'col-md-6 col-lg-4'}
            >
                <h1
                    style={{marginTop: 30}}
                >
                    {TPollCreatorScreen[AppConfig.lang].POLL}
                </h1>
                <View
                    className={'card'}
                >
                    <View
                        className={'card-body'}
                    >
                        <ChocoForm
                            containerStyle={{padding: 0}}
                            lang={AppConfig.lang}
                            form={mainForm}
                            onFormChange={(updatedForm) => {
                                setMainForm(updatedForm)
                            }}
                        />
                    </View>
                </View>
            </View>
            <View
                className={'col-md-6 col-lg-8'}
            >
                <h1
                    style={{marginTop: 30}}
                >
                    {TPollCreatorScreen[AppConfig.lang].QUESTIONS}
                </h1>
                <QuestionList
                    initialQuestions={questions}
                    onListChange={(newList) => {
                        setQuestions(newList);

                        setQuestionsChanged(true)
                    }}
                />
            </View>
            <View>
                <BottomActionBar>
                    <View
                        style={{width: '100%'}}
                    >
                        {
                            errorMsg ?
                                <div style={{marginTop: 15}} className={'alert alert-danger'}>{errorMsg}</div>
                                :
                                null
                        }
                        {
                            successMsg ?
                                <div style={{marginTop: 15}} className={'alert alert-success'}>{successMsg}</div>
                                :
                                null
                        }
                        <View
                            style={{flexDirection: 'row', justifyContent: 'flex-end'}}
                        >
                            <BorderlessButton
                                text={TPollCreatorScreen[AppConfig.lang].CANCEL}
                                onPress={() => {
                                    navigate(-1)
                                }}
                            />
                            <View style={{ width: 7 }}></View>
                            <ThemeButton
                                disabled={(!mainForm.isValidForm && !questionsChanged) || saving}
                                text={
                                    saving ?
                                        <ActivityIndicator color={'white'} size={24}/>
                                        :
                                        TPollCreatorScreen[AppConfig.lang].SAVE
                                }
                                onPress={save}
                            />
                        </View>
                    </View>
                </BottomActionBar>
            </View>
            <View style={{height: 200}}></View>
        </View>
    </ScrollView>
}

export default PollCreatorScreen;